import React, { createContext, useContext, ReactNode } from "react";

interface ProfileAutofillContextType {
  handleUrlAnalysis?: (url: string) => Promise<void>;
}

const ProfileAutofillContext = createContext<ProfileAutofillContextType | undefined>(undefined);

export const ProfileAutofillProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <ProfileAutofillContext.Provider value={{}}>
      {children}
    </ProfileAutofillContext.Provider>
  );
};

export const useProfileAutofill = () => {
  const ctx = useContext(ProfileAutofillContext);
  if (!ctx) throw new Error("useProfileAutofill must be used within ProfileAutofillProvider");
  return ctx;
};

export const setProfileAutofillHandler = (handler: (url: string) => Promise<void>) => {
  // Store in a module-level variable accessible from anywhere
  (window as any).__profileAutofillHandler = handler;
};

export const getProfileAutofillHandler = (): ((url: string) => Promise<void>) | undefined => {
  return (window as any).__profileAutofillHandler;
};
